import './MonitorDetails.scss';
import classNames from 'classnames';
import { ConfigurableFieldAccess } from './ConfigurableFieldAccess';
import { MONITOR_VALIDATION_RULES } from '@security/@arch/validation';
import React from 'react';
import { SetupAuditTrail } from './SetupAuditTrail';
import { SonarText } from '@ui/text';
import { Uptime } from '.';
import { When } from 'react-if';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { DataSecurityMonitorType } from '@sonar-software/sonar-core';
import { Form, Input, Space } from 'antd';
export const MonitorDetails = ({ editing = false, fieldId, hideName = false, noMargin = false, monitor }) => {
    let details = undefined;
    switch (monitor.monitorConfig.monitorTypeId) {
        case DataSecurityMonitorType.Uptime:
            details = React.createElement(Uptime, { editing: editing, fieldId: fieldId, monitor: monitor });
            break;
        case DataSecurityMonitorType.SetupAuditTrail:
            details = React.createElement(SetupAuditTrail, { monitor: monitor });
            break;
        case DataSecurityMonitorType.ConfigurableFieldAccess:
            details = React.createElement(ConfigurableFieldAccess, null);
            break;
        default:
    }
    return (React.createElement(Space, { align: 'start', className: classNames('monitor-details', { margin: !noMargin }), direction: 'vertical' },
        React.createElement(SonarText, { className: 'h2' }, COPY_SPECIFIC.MONITOR_DETAILS),
        React.createElement(When, { condition: !hideName },
            React.createElement(Form.Item, { className: 'monitor-details-name', id: 'monitor-details-name', initialValue: monitor.name, label: COPY_SPECIFIC.NAME, name: fieldId === undefined ? 'name' : [fieldId, 'name'], rules: [...MONITOR_VALIDATION_RULES.NAME] },
                React.createElement(Input, { disabled: !editing, placeholder: PLACEHOLDERS_COPY.NAME_YOUR_MONITOR }))),
        details));
};
